import React from 'react';
import { useSelector } from 'react-redux';

import { Navigate, Outlet } from 'react-router-dom'


const ProtectedRoutes = (props) => {
    const isAuth = useSelector((state) => state.user.isAuthenticated)
    return isAuth ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoutes;